import { Injectable } from '@angular/core';

import { merge, Observable, of, switchMap, take } from 'rxjs';

import { ScheduleService } from './schedule.service';
import { ServicesService } from './services.service';
import { ResourcesService } from './resources.service';
import { AuthRestaurantService } from '@tablesready/frontend-store';

/**
 * This service is responsible for loading base data and subscribing to its updates
 */
@Injectable({providedIn: 'root'})
export class DataLoaderService {
  constructor(
    private readonly authRestaurantService: AuthRestaurantService,
    private readonly scheduleService: ScheduleService,
    private readonly servicesService: ServicesService,
    private readonly resourcesService: ResourcesService,
  ) {
  }

  load(): Observable<any> {
    return this.authRestaurantService.select()
      .pipe(
        take(1),
        switchMap(user => {
          if (user.location) {
            return merge(
              this.scheduleService.load(),
              this.servicesService.load(),
              this.resourcesService.load(),
            );
          }

          return of(null);
        })
      );
  }

  reset() {
    this.scheduleService.reset();
    this.servicesService.reset();
    this.resourcesService.reset();
  }

  listenToChanges() {
    return merge(
      this.scheduleService.listenToChanges(),
      this.servicesService.listenToChanges(),
      this.resourcesService.listenToChanges(),
    );
  }
}
